
































































































import { Component, Mixins } from 'vue-property-decorator';

import ScreenSizeVisibility from '@/shared/components/ScreenSizeVisibility/ScreenSizeVisibility.vue';
import WPButton from '@/shared/components/WPButton/WPButton.vue';

import PartnerMixin from '@/shared/mixins/PartnerMixin';

import TermsDesktopModal from '@/shared/components/Terms/TermsDesktopModal.vue';
import TermsMobileModal from '@/shared/components/Terms/TermsMobileModal.vue';
import PolicyDesktopModal from '@/shared/components/Terms/PolicyDesktopModal.vue';
import PolicyMobileModal from '@/shared/components/Terms/PolicyMobileModal.vue';

import PaymentTooltip from '@/app/features/Checkout/features/Payment/components/PaymentTooltip.vue';

@Component({
  components: {
    PaymentTooltip,
    TermsDesktopModal,
    TermsMobileModal,
    PolicyDesktopModal,
    PolicyMobileModal,
    ScreenSizeVisibility,
    WPButton,
  },
})
export default class Footer extends Mixins(PartnerMixin) {
  private get isMobile () {
    return this.$vuetify.breakpoint.smAndDown;
  }

  private get canShowNewMethods () {
    return process.env.VUE_APP_NEW_METHODS_FOOTER_VISIBILITY === 'true';
  }

  private get showPaymentMethods () {
    return !this.isPartnerVisible;
  }

  private get showMercadoPagoLogoFooter() {
    return this.$route.query.mp === '1';
  }
}
